import React, { createContext, useContext } from 'react';
import { useEmailVerificationGuard } from '../../hooks/useEmailVerificationGuard';
import EmailVerificationModal from './EmailVerificationModal';

interface EmailVerificationContextType {
  requireVerification: (actionName: string, actionDescription: string, callback: () => void) => void;
  isVerified: boolean;
}

const EmailVerificationContext = createContext<EmailVerificationContextType | undefined>(undefined);

export const EmailVerificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { requireVerification, modalState, closeModal, onVerificationComplete, isVerified } = useEmailVerificationGuard();

  return (
    <EmailVerificationContext.Provider value={{ requireVerification, isVerified }}>
      {children}
      
      <EmailVerificationModal
        isOpen={modalState.isOpen}
        actionName={modalState.actionName}
        actionDescription={modalState.actionDescription}
        onClose={closeModal}
        onVerificationComplete={onVerificationComplete}
      />
    </EmailVerificationContext.Provider>
  );
};

export const useEmailVerification = () => {
  const context = useContext(EmailVerificationContext);
  if (context === undefined) {
    throw new Error('useEmailVerification must be used within an EmailVerificationProvider');
  }
  return context;
};